export const module = {
  info: {
    name: 'voip-testing-panel-setting',
    caption: 'voip testing panel setting',
    viewGroup: 'general-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    caption: 'Testing Panel Setting',
    icon: 'el-icon-setting mt-1',
    routeName: 'module->voip-testing-panel-setting->create',
    children: [
      {
        caption: 'Profile Default Setting',
        icon: 'el-icon-s-tools',
        routeName: 'module->voip-testing-panel-default-setting->panel'
      },
      {
        caption: 'User Setting',
        icon: 'el-icon-setting',
        routeName: 'module->voip-testing-panel-user-setting->panel',
      }
    ]
  }
}

export default module
